'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.policyShape = exports.materialPolicyShape = exports.availabilityShape = undefined;

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bibBriefShape = require('./bibBriefShape');

var _bibBriefShape2 = _interopRequireDefault(_bibBriefShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var availabilityShape = exports.availabilityShape = _reactImmutableProptypes2.default.mapContains({
  availabilityLocationType: _react.PropTypes.string,
  availableCopies: _react.PropTypes.number,
  bibType: _react.PropTypes.string,
  circulationType: _react.PropTypes.string,
  eresourceDescription: _react.PropTypes.string,
  eresourceUrl: _react.PropTypes.string,
  heldCopies: _react.PropTypes.number,
  libraryUseOnly: _react.PropTypes.bool,
  localisedStatus: _react.PropTypes.string,
  metadataId: _react.PropTypes.string,
  singleBranch: _react.PropTypes.bool,
  status: _react.PropTypes.string,
  totalCopies: _react.PropTypes.number
});

var materialPolicyShape = exports.materialPolicyShape = _reactImmutableProptypes2.default.mapContains({
  externalAPI: _react.PropTypes.bool,
  healthy: _react.PropTypes.bool,
  helpUrl: _react.PropTypes.string,
  itemLevelHoldsPredetermined: _react.PropTypes.bool,
  quickStartUrl: _react.PropTypes.string,
  requiresDuration: _react.PropTypes.bool,
  requiresEmailDuringHold: _react.PropTypes.bool,
  requiresFormatDuringCheckout: _react.PropTypes.bool,
  requiresFormatDuringHold: _react.PropTypes.bool,
  showFormatDuringCheckout: _react.PropTypes.bool,
  showFormatDuringHold: _react.PropTypes.bool,
  showQuickstartLink: _react.PropTypes.bool,
  supportAutoCheckout: _react.PropTypes.bool,
  supportsBatchVolumeHolds: _react.PropTypes.bool,
  supportsDownload: _react.PropTypes.bool,
  supportsFastAvailability: _react.PropTypes.bool,
  supportsReadNow: _react.PropTypes.bool,
  supportsSuspendHold: _react.PropTypes.bool
});

var policyShape = exports.policyShape = _reactImmutableProptypes2.default.mapContains({
  holdable: _react.PropTypes.bool,
  itemLevelHoldableItems: _react.PropTypes.bool,
  materialPolicy: materialPolicyShape,
  materialType: _react.PropTypes.string,
  provider: _react.PropTypes.string
});

exports.default = _reactImmutableProptypes2.default.mapContains({
  availability: availabilityShape,
  briefInfo: _bibBriefShape2.default,
  id: _react.PropTypes.string,
  policy: policyShape
});


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/bibShape.js
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16